import ThemeColors from "../colors";

const overrideComponents = (direction) => ({
    MuiFormHelperText: {
        styleOverrides: {
            root: {
                textAlign: direction === 'rtl' ? 'right' : 'left'
            }
        },
    },
    MuiTextField: {
        styleOverrides: {
            root: {
                direction,
                ".MuiInputBase-root.Mui-disabled": {
                    background: ThemeColors.lighterGreyColor,
                },
                label: {
                    transformOrigin: direction === 'rtl' ? 'right' : 'left',
                    right: '1.75rem',
                },
                fieldset: {
                    textAlign: direction === 'rtl' ? 'right' : 'left',
                    borderColor: ThemeColors.blackColor
                }
            },
        },
    },
    MuiButton: {
        styleOverrides: {
            root: {
                borderRadius: 4,
                '& .MuiSvgIcon-root': {
                    marginLeft: 4,
                    marginRight: 12,
                }
            }
        }
    },
    MuiAlert: {
        styleOverrides: {
            root: {
                flexDirection: direction === 'ltr' ? 'row' : 'row-reverse'
            }
        }
    },
    MuiAutocomplete: {
        styleOverrides: {
            root: {
                "& .MuiAutocomplete-inputRoot": {
                paddingRight: direction === 'rtl' && '10px !important',
                },
                "& .MuiAutocomplete-endAdornment": {
                    right: direction === 'ltr' ? '9px !important' : 'unset !important',
                    left: direction === 'rtl' ? '9px !important' : 'unset !important'

                }

            }
        }
    }
})

export default overrideComponents